import { MutableRefObject, RefCallback, useEffect, useRef } from 'react'

/**
 * Fix the original useEnsuredForwardedRef hook that doesn't accept RefCallback | null as forwardedRef [Ref](https://github.com/streamich/react-use/issues/805)
 */
const useEnsuredForwardedRef = <T>(
  forwardedRef: MutableRefObject<T | null> | RefCallback<T> | null,
): MutableRefObject<T | null> => {
  const ensuredRef = useRef<T | null>(
    forwardedRef && 'current' in forwardedRef ? forwardedRef.current : null,
  )

  useEffect(() => {
    if (!forwardedRef) {
      return
    }
    if (typeof forwardedRef === 'function') {
      forwardedRef(ensuredRef.current)
    } else {
      forwardedRef.current = ensuredRef.current
    }
  }, [forwardedRef])

  return ensuredRef
}

export default useEnsuredForwardedRef
